import { useNode } from '@craftjs/core';
import { ListSubheader, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import { SettingCard } from '@/components';
import SpacingSettings from '@/components/editor/settings/SpacingSettings/SpacingSettings';
import ClassSettings from '@/components/editor/settings/ClassSettings';

const RegionSettings = () => {
  const {
    props: { region = '' },
    actions: { setProp },
  } = useNode((node) => ({
    region: node.data.props.region,
    props: node.data.props,
  }));

  return (
    <Stack spacing={2}>
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>

      <SettingCard title="Región">
        <Select
          name="regions"
          size="small"
          value={region}
          fullWidth
          onChange={(event: SelectChangeEvent<string>) => {
            const value = event.target.value;
            setProp((props: { region: string }) => {
              props.region = value;
            });
          }}
        >
          <ListSubheader>Menú</ListSubheader>
          <MenuItem value="header">Cabecera</MenuItem>
          <MenuItem value="footer">Pie de Página</MenuItem>
          <ListSubheader>Sitio web</ListSubheader>
          <MenuItem value="website-popup">Ventana Flotante</MenuItem>
        </Select>
      </SettingCard>

      <SettingCard title="Espaciado">
        <SpacingSettings />
      </SettingCard>
    </Stack>
  );
};

export default RegionSettings;
